import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <Link 
        to="/homepage" 
        className="inline-flex items-center space-x-3 mb-6 hover:opacity-80 transition-opacity duration-200"
      >
        <div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center shadow-elevation-2">
          <Icon name="Sparkles" size={28} color="white" />
        </div>
        <div className="text-left">
          <h1 className="text-2xl font-bold text-text-primary">Clean360</h1>
          <p className="text-sm text-text-secondary">Professional Cleaning Services</p>
        </div>
      </Link>

      {/* Welcome Message */}
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          Welcome Back
        </h2>
        <p className="text-text-secondary">
          Sign in to access your account and manage your cleaning services
        </p>
      </div>

      {/* Demo Credentials Notice */}
      <div className="bg-primary/10 border border-primary/20 rounded-lg p-4 mb-6">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="text-left">
            <h3 className="text-sm font-semibold text-primary mb-2">Demo Credentials</h3>
            <div className="space-y-2 text-xs">
              <div>
                <p className="font-medium text-text-primary">Customer Account:</p>
                <p className="text-text-secondary">Email: customer@clean360.com</p>
                <p className="text-text-secondary">Password: customer123</p>
              </div>
              <div>
                <p className="font-medium text-text-primary">Admin Account:</p>
                <p className="text-text-secondary">Email: admin@clean360.com</p>
                <p className="text-text-secondary">Password: admin123</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;